// extracted by mini-css-extract-plugin
module.exports = {"entryButton":"entry_button-module--entry-button--2aSXf","entryButton__link":"entry_button-module--entry-button__link--1hobZ","shine":"entry_button-module--shine--1Kqly"};